// @flow

import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../components/image';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Assets from '../../../../assets';
import { AppConfig } from '../../../../config';
import {
    Typography,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    Link,
} from '@material-ui/core';
import { type CardCMS } from '../../../../data/cms/types/download-sdk';

import './style.css';

type Props = {
    Content: CardCMS,
};

function Cards(props: Props) {
    const { Content } = props;

    return (
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <Typography component="div" className="documents-content">
                <List>
                    <ListItem>
                        <ListItemAvatar>
                            <Image
                                src={Assets.Icons.Bolt.Path}
                                alt={Assets.Icons.Bolt.Alt}
                                className="documents-img"
                            />
                        </ListItemAvatar>
                        <Typography component="h4">{Content.Title}</Typography>
                    </ListItem>
                </List>
                <Typography component="span">{Content.Line1}</Typography>
                <Typography component="div" className="documents-ac-btn">
                    <ArrowRightAltIcon />
                    <Link href={`${AppConfig.Scripts}${Content.URL}`} download>
                        {Content.link}
                    </Link>
                </Typography>
            </Typography>
        </Grid>
    );
}
Cards.propTypes = {
    Content: PropTypes.object,
    keys: PropTypes.array,
};

export default Cards;
